import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-update-product',
  templateUrl: './update-product.component.html',
  styleUrls: ['./update-product.component.css']
})
export class UpdateProductComponent implements OnInit {

  form: any | FormGroup
  product:any = []
  ProductId: any = "";
  cid:any
  singleProduct:any;

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  uomSelectedList1:any = [];
  uomDropdownList:any = [];
  uomSelectedList:any = [];
  uomDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  uomData:any = [];
  isDefault:any = ""
  ProductParams:any = []
  keyValueList:any = []
  imageUrlList:any = []

  productSpecifications:any = [
    {
      "key": "",
      "value": "",
      "keyValue": []
    }
  ]

  tags:any = [
    {
      "key": "",
    }
  ]

  relatedProductList:any = []
  similarProductList:any = []
  vendorMasters:any = []
  vendorMastersList:any = []

  vendorMastersDropdownList:any = [];
  vendorMastersSelectedList:any = [];
  vendorMastersDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'vendorMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  relatedProductDropdownList:any = [];
  relatedProductSelectedList:any = [];
  relatedProductDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'productMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  similarProductDropdownList:any = [];
  similarProductSelectedList:any = [];
  similarProductDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'productMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  productSaleTypeList:any = [
    {
      isChecked: false,
      type: "Click & Collect"
    },
    {
      isChecked: false,
      type: "Delivery"
    },
    {
      isChecked: false,
      type: "Instore Shopping"
    }
  ];

  currencyType:any = [
    {
      "currencyId": "6",
      "currencyName": "Euro",
      "currencySymbol": "€",
      "currencyRate": "1.17",
      "status": "0",
      "createddate": "07-09-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "5",
      "currencyName": "Saudi Riyal",
      "currencySymbol": "SR",
      "currencyRate": "4",
      "status": "0",
      "createddate": "10-08-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "4",
      "currencyName": "Dinar",
      "currencySymbol": "KD",
      "currencyRate": "0.42",
      "status": "0",
      "createddate": "06-08-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "3",
      "currencyName": "Sterling pound",
      "currencySymbol": "£",
      "currencyRate": "1",
      "status": "0",
      "createddate": "14-07-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "2",
      "currencyName": "Australian Dollar",
      "currencySymbol": "DLRe",
      "currencyRate": "50",
      "status": "0",
      "createddate": "12-07-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "1",
      "currencyName": "Indian Rupee",
      "currencySymbol": "RS",
      "currencyRate": "10",
      "status": "0",
      "createddate": "08-07-2021",
      "createdBy": "1",
      "version": "1"
    },
    {
      "currencyId": "0",
      "currencyName": "GBP",
      "currencySymbol": "£",
      "currencyRate": "1",
      "status": "1",
      "createddate": "29-07-2021",
      "createdBy": "1",
      "version": "1"
    }
  ]

  taxInfoList:any = [];
  taxMasterList:any = []
  taxInfoDropdownList:any = [];
  taxInfoSelectedList:any = [];
  taxInfoDropdownSettings:IDropdownSettings = {
    singleSelection: false,
    idField: 'taxMasterId',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
  editProduct: boolean = false;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getallproduct(this.pageNumber,this.recordsPerPage)
    this.form = this.fb.group({
      name: [''],
      version: [''],
      group:[''],
      code:[''],
      description:[''],
      image: [''],
      sku: ['']
    })
    this.getAllUomMaster()
    this.getParamByType()
    this.getAllTaxMaster()
    this.getallVendor()
  }

  getProductById(id:any){
    this.ProductId = id
    this.generic_service.getProductById(id).subscribe(
      (response:any)=>{
        this.singleProduct = response.response
        this.form.patchValue({
          name: response.response.name,
          version: response.response.version,
          group: response.response.group,
          description: response.response.description,
          code: response.response.code,
          image: response.response.imageUrl,
          sku: response.response.sku
        })

        this.imageUrlList = response.response.imageUrlList
        this.uomSelectedList1 = response.response.supportedUOM;
        for(let i=0; i<response.response.supportedUOM.length;i++){
          if(response.response.supportedUOM[i].isDefault){
            this.isDefault = String(response.response.supportedUOM[i].uomId)
          }
          this.uomSelectedList.push(
            {
              "uomMasterId": response.response.supportedUOM[i].uomId,
              "uomName": response.response.supportedUOM[i].uomName
            }
          )
        }

        if(response.response.productSpecifications.length != 0){
          this.productSpecifications = []
        }

        for(let i=0; i<response.response.productSpecifications.length;i++){
          this.productSpecifications.push(
            {
              "key": response.response.productSpecifications[i].key,
              "value": response.response.productSpecifications[i].value,
              "keyValue": []
            }
          )
        }

        this.vendorMasters = response.response.vendorMasters
        for(let i=0; i<response.response.vendorMasters.length;i++){
          this.vendorMastersSelectedList.push(
            {
              "vendorMasterId": response.response.vendorMasters[i].vendorMasterId,
              "name": response.response.vendorMasters[i].name
            }
          )
        }

        this.relatedProductList = response.response.relatedProductList
        for(let i=0; i<response.response.relatedProductList.length;i++){
          this.relatedProductSelectedList.push(
            {
              "productMasterId": response.response.relatedProductList[i].productMasterId,
              "name": response.response.relatedProductList[i].name
            }
          )
        }
        this.similarProductList = response.response.similarProductList
        for(let i=0; i<response.response.similarProductList.length;i++){
          this.relatedProductSelectedList.push(
            {
              "productMasterId": response.response.similarProductList[i].productMasterId,
              "name": response.response.similarProductList[i].name
            }
          )
        }

        this.taxInfoList = response.response.taxInfoList
        for(let i=0; i<response.response.taxInfoList.length;i++){
          this.taxInfoSelectedList.push(
            {
              "taxMasterId": response.response.taxInfoList[i].taxMasterId,
              "name": response.response.taxInfoList[i].name
            }
          )
        }

        for(let i=0; i<response.response.productSaleType.length;i++){
          for(let j=0; j<this.productSaleTypeList.length;j++){
            if(this.productSaleTypeList[j].type == response.response.productSaleType[i]){
              this.productSaleTypeList[j].isChecked = true
            }
          }
        }

        if(response.response.tags.length != 0){
          this.tags = []
        }
        for(let i=0; i<response.response.tags.length;i++){
          this.tags.push(
            {
              "key": response.response.tags[i]
            }
          )
        }

        this.editProduct = true

      },
      (error)=>{
        console.log(error)
      }
    )
  }

  addProductSpecifications(){
    this.productSpecifications.push(
      {
        "key": "",
        "value": "",
        "keyValue": []
      }
    )
  }

  removeProductSpecifications(index: any){
    this.productSpecifications.splice(index,1)
  }

  addTags(){
    this.tags.push(
      {
        "key": ""
      }
    )
  }

  removeTags(index: any){
    this.tags.splice(index,1)
  }

  getAllTaxMaster(){
    this.generic_service.getAllTaxMaster().subscribe(
      (response:any)=>{
        this.taxInfoDropdownList = response.response
        this.taxMasterList = response.response
      }
    )
  }

  onTaxInfoSelect(item: any){
    for(let i=0; i<this.taxMasterList.length; i++) {
      if(this.taxMasterList[i].taxMasterId == item.taxMasterId){
        this.taxInfoList.push(
          {
            "id": this.taxMasterList[i].id,
            "taxMasterId": this.taxMasterList[i].taxMasterId,
            "name": this.taxMasterList[i].name,
            "percentage": this.taxMasterList[i].percentage,
            "amount": this.taxMasterList[i].amount,
            "cid": this.taxMasterList[i].cid,
          }
        )
      }
    }
  }

  onDeSelectTaxMaster(item: any) {
    let taxIndex = 0;
    for(let i = 0; i < this.taxInfoList.length;i++) {
      if(this.taxInfoList[i].taxMasterId == item.taxMasterId) {
        taxIndex = i;
      }
    }
    this.taxInfoList.splice(taxIndex,1)
  }

  getallVendor(){
    // this.generic_service.getVendor().subscribe(
    //   (response:any)=>{
    //     this.vendorMastersList = response.response;
    //     this.vendorMastersDropdownList = response.response
    //   }
    // )
  }

  getallproduct(pageNumber:any,recordsPerPage:any){
    this.generic_service.getProduct(pageNumber,recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.product = response.response.productMasterList;
        this.totalRecords = response.response.totalRecords;
      }
    )
  }


  onRelatedProductSelect(item: any){
    for(let i=0; i<this.product.length; i++) {
      if(this.product[i].productMasterId == item.productMasterId){
        this.relatedProductList.push(
          {
            "id": this.product[i].id,
            "productMasterId": this.product[i].productMasterId,
            "name": this.product[i].name,
            "imageUrl": this.product[i].imageUrl,
            "supportedUOM": this.product[i].supportedUOM
          }
        )
      }
    }
  }

  onFilterChange(item: any) {
  }

  onDropDownClose(item: any) {
  }

  onDeSelect(item: any) {
    let productIndex = 0;
    for(let i = 0; i < this.relatedProductList.length;i++) {
      if(this.relatedProductList[i].productMasterId == item.productMasterId) {
        productIndex = i;
      }
    }
    this.relatedProductList.splice(productIndex,1)
  }

  onDeSelectAll(items: any) {
  }

  onRelatedProductSelectAll(items: any) {
  }

  onItemSelect(item: any) {
    console.log(item)
    this.uomSelectedList1.push(
      {
        "uomId": item.uomMasterId,
        "uomName": item.uomName,
        "price": 0,
        "discountedPrice": 0,
        "quantity": 0,
        "cid": 0,
        "isDefault": false,
        "color": "",
        "currencyType": "",
        "currencySymbol": "",
        "minOrderQuantity": 0,
        "maxOrderQuantity": 0
      }
    )
  }

  onSelectAll(items: any) {
  }

  getAllUomMaster(){
    this.generic_service.getAllUomMaster().subscribe(
      (res:any)=> {
        this.uomDropdownList = res.response
        this.uomData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  currencyChanged(currency:any,index:any) {
    for(let i = 0; i < this.currencyType.length; i++) {
      
    }
  }

  updateProduct(){
    let tags:any = []
    for(let i = 0; i < this.tags.length; i++){
      tags.push(this.tags[i].key)
    }

    for(let j = 0; j < this.uomSelectedList1.length;j++) {
      if(this.uomSelectedList1[j].uomId == Number(this.isDefault)){
        this.uomSelectedList1[j].isDefault = true;
      }
    }

    let keyValueList:any = []
    for(let i = 0; i < this.keyValueList.length; i++){
      keyValueList.push(
        {
          "key": this.keyValueList[i].key,
          "value": this.keyValueList[i].value
        }
      )
    }

    let productSaleType:any = []
    for(let i = 0; i < this.productSaleTypeList.length; i++){
      if(this.productSaleTypeList[i].isChecked == true){
        productSaleType.push(this.productSaleTypeList[i].type)
      }
    }

    let body = {
      "createdBy": null,
      "createdDate": 0,
      "modifiedBy": null,
      "modifiedDate": 0,
      "version": String(this.form.get('version').value),
      "isActive": true,
      "description": String(this.form.get('description').value),
      "code": String(this.form.get('code').value),
      "name": String(this.form.get('name').value),
      "group": String(this.form.get('group').value),
      "supportedUOM": this.uomSelectedList1,
      "keyValueList": keyValueList,
      "status": "",
      "imageUrl": String(this.form.get('image').value),
      "sku": String(this.form.get('sku').value),
      "cid": this.cid,
      "productSpecifications": this.productSpecifications,
      "imageUrlList": this.imageUrlList,
      "relatedProductList": this.relatedProductList,
      "similarProductList": this.similarProductList,
      "vendorMasters": this.vendorMasters,
      "productSaleType": productSaleType,
      "taxInfoList": this.taxInfoList,
      "productRating": 0,
      "tags": tags,
      "productMasterId": this.singleProduct.productMasterId,
      "objectTemplateId": this.singleProduct.objectTemplateId
    }
    this.generic_service.updateProduct(body).subscribe(
      (response:any)=>{
        this.getallproduct(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success(response.message);
        this.cancelModel()
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  onTableDataChange(event: any) {
    this.pageNumber = event;
    this.getallproduct(this.pageNumber-1,this.recordsPerPage)
  }

  getParamByType(){
    this.generic_service.getParamByType('PRODUCTPARAMS').subscribe(
      (response:any)=>{
        this.ProductParams = response.response;
        for(let i=0; i<this.ProductParams.length;i++){
          this.keyValueList.push(
            {
              "key": this.ProductParams[i].name,
              "value": "",
              "possibleValue": this.ProductParams[i].possibleValue
            }
          )
        }
      }
    )
  }

  onChange(event: any) {
    this.onUpload(event.target.files[0])
  }

  onUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe(
      (event: any) => {
        this.form.patchValue(
          {      
            image: event.response
          }
        );
      }
    );
  }

  imageRemove(){
    this.form.patchValue(
      {      
        image: ""
      }
    )
  }

  imageButtonClick(){
    document.getElementById("imageInput")?.click()
  }

  imageListButtonClick(){
    document.getElementById("imageListInput")?.click()
  }

  onListChange(event: any) {
    this.onListUpload(event.target.files[0])
  }

  onListUpload(file: any) {
    this.generic_service.uploadImage(file).subscribe((event: any) => {
      this.imageUrlList.push(event.response);
    });
  }

  imageListRemove(index:any){
    this.imageUrlList.splice(index,1)
  }

  removeRelatedProductList(index:any,productMasterId:any) {
    this.relatedProductList.splice(index,1)
    let productIndex = 0;
    for(let i = 0; i < this.relatedProductSelectedList.length;i++) {
      if(this.relatedProductSelectedList[i].productMasterId == productMasterId) {
        productIndex = i;
      }
    }
    this.relatedProductSelectedList.splice(productIndex,1)
  }

  onSimilarProductSelect(item: any){
    for(let i=0; i<this.product.length; i++) {
      if(this.product[i].productMasterId == item.productMasterId){
        this.similarProductList.push(
          {
            "id": this.product[i].id,
            "productMasterId": this.product[i].productMasterId,
            "name": this.product[i].name,
            "imageUrl": this.product[i].imageUrl,
            "supportedUOM": this.product[i].supportedUOM
          }
        )
      }
    }
  }

  onDeSelectSimilar(item: any) {
    let productIndex = 0;
    for(let i = 0; i < this.similarProductList.length;i++) {
      if(this.similarProductList[i].productMasterId == item.productMasterId) {
        productIndex = i;
      }
    }
    this.similarProductList.splice(productIndex,1)
  }

  vendorSelect(item: any){
    for(let i=0; i<this.vendorMastersList.length; i++) {
      if(this.vendorMastersList[i].vendorMasterId == item.vendorMasterId){
        this.vendorMasters.push(
          {
            "version": this.vendorMastersList[i].version,
            "isActive": this.vendorMastersList[i].isActive,
            "description": this.vendorMastersList[i].description,
            "vendorMasterId": this.vendorMastersList[i].vendorMasterId,
            "code": this.vendorMastersList[i].code,
            "name": this.vendorMastersList[i].name,
            "status": this.vendorMastersList[i].status,
            "cid": this.vendorMastersList[i].cid
          }
        )
      }
    }
  }

  onDeSelectVendor(item: any) {
    let vendorIndex = 0;
    for(let i = 0; i < this.vendorMasters.length;i++) {
      if(this.vendorMasters[i].vendorMasterId == item.vendorMasterId) {
        vendorIndex = i;
      }
    }
    this.vendorMasters.splice(vendorIndex,1)
  }

  closeEdit(){
    this.editProduct = false;
  }

}
